(function(){
  if(window.__nzcUpDelegated) return; window.__nzcUpDelegated = true;
  var stripping = false;
  function refreshCart(){
    try {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true,
        detail: { resource: null, sourceId: 'nzc-gift-upsell', data: { source: 'nzc-gift-upsell' } } }));
    } catch(e) { window.location.reload(); }
  }
  function post(url, body){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
      .then(function(r){ if(!r.ok) throw 0; return r.json().catch(function(){ return {}; }); });
  }
  // Discounts can't see selling-plan lines. Normalize: strip plans from tallow lines
  // so the gift engine always works, regardless of how the line was added.
  function stripTallowPlans(){
    if(stripping) return Promise.resolve(false);
    stripping = true;
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var targets = (cart.items||[]).filter(function(it){
        return it.handle === 'manuka-honey-tallow-balm' && it.selling_plan_allocation; });
      var chain = Promise.resolve();
      targets.forEach(function(it){
        chain = chain.then(function(){ return post('/cart/change.js', { id: it.key, quantity: it.quantity, selling_plan: null }); });
      });
      return chain.then(function(){ stripping = false; return targets.length > 0; });
    }).catch(function(){ stripping = false; return false; });
  }
  function normalizeAndMaybeRefresh(){
    stripTallowPlans().then(function(changed){ if(changed) refreshCart(); });
  }
  // run on load + whenever the cart changes (covers STOQ's own widget adds)
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', normalizeAndMaybeRefresh); }
  else { normalizeAndMaybeRefresh(); }
  var debounce;
  document.addEventListener('cart:update', function(ev){
    if(ev && ev.detail && ev.detail.sourceId === 'nzc-gift-upsell') return; // our own refresh; avoid loops
    clearTimeout(debounce); debounce = setTimeout(normalizeAndMaybeRefresh, 400);
  });
  document.addEventListener('click', function(ev){
    var b = ev.target && ev.target.closest ? ev.target.closest('.nzc-up') : null;
    if(!b) return;
    ev.preventDefault(); ev.stopPropagation();
    var box = b.closest('.nzc-gift-box'); if(!box) return;
    var TEN = box.getAttribute('data-ten'), TAL = box.getAttribute('data-tal');
    var action = b.getAttribute('data-action') || 'add';
    b.style.opacity='.6'; b.disabled=true;
    function fail(){ b.style.opacity='1'; b.disabled=false; }
    if(action === 'add'){
      var items; try{ items=JSON.parse(b.getAttribute('data-items')); }catch(e){ return fail(); }
      post('/cart/add.js',{items:items}).then(stripTallowPlans).then(refreshCart).catch(fail);
    } else if(action === 'remove10'){
      var u={updates:{}}; u.updates[TEN]=0;
      post('/cart/update.js',u).then(refreshCart).catch(fail);
    } else if(action === 'swap'){
      post('/cart/add.js',{items:[{id:parseInt(TAL,10),quantity:1}]})
        .then(stripTallowPlans)
        .then(function(){ var u={updates:{}}; u.updates[TEN]=0; return post('/cart/update.js',u); })
        .then(refreshCart).catch(fail);
    }
  }, true);

  // ── Drawer "Upgrade to 30ml" (snippets/nz-drawer-upsell.liquid) ─────────────────────────────
  // 2026-09-13: the drawer is re-rendered after every cart change and only exists once the cart has
  // items, so a script inside the snippet never runs reliably. Delegated here, bound once per page,
  // config re-read from the live #nz-dupsell element at click time.
  function dupsellCfg(){
    var el = document.getElementById('nz-dupsell');
    if(!el) return null;
    return {
      term: (el.dataset.triggerTerm || '10ml').toLowerCase(),
      minQty: parseInt(el.dataset.minQty, 10) || 2,
      price: parseInt(el.dataset.upsellPrice, 10) || 0,
      vid: el.dataset.upsellVariantId
    };
  }
  function dupsellTrigger(items, term){
    var qty = 0, price = 0, variantIds = [];
    (items || []).forEach(function(item){
      var inTitle = item.title && item.title.toLowerCase().indexOf(term) !== -1;
      var inVariant = item.variant_title && item.variant_title.toLowerCase().indexOf(term) !== -1;
      if(inTitle || inVariant){ qty += item.quantity; price = item.price; variantIds.push(item.variant_id); }
    });
    return { qty: qty, price: price, variantIds: variantIds };
  }
  function dupsellUpdate(cart){
    var el = document.getElementById('nz-dupsell'), c = dupsellCfg();
    if(!el || !c || !cart || !cart.items) return;
    var d = dupsellTrigger(cart.items, c.term);
    var diff = c.price - (d.price * d.qty);
    var show = d.qty >= c.minQty && diff > 0;
    el.classList.toggle('nz-dupsell--hidden', !show);
    var headline = document.getElementById('nz-dupsell-headline');
    if(show && headline){
      headline.textContent = 'Swap your ' + d.qty + '× 10ml for a 30ml — 3× the oil for only ' +
        (diff / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }) + ' more.';
    }
  }
  document.addEventListener('cart:update', function(e){ dupsellUpdate(e.detail && (e.detail.resource || e.detail.cart)); });
  document.addEventListener('cart:updated', function(e){ dupsellUpdate(e.detail && (e.detail.cart || e.detail.resource)); });
  document.addEventListener('click', function(ev){
    var btn = ev.target && ev.target.closest ? ev.target.closest('#nz-dupsell-btn') : null;
    if(!btn) return;
    ev.preventDefault(); ev.stopPropagation();
    var c = dupsellCfg(); if(!c || !c.vid) return;
    btn.disabled = true; btn.textContent = 'Upgrading…';
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var d = dupsellTrigger(cart.items, c.term);
      if(!d.variantIds.length){ window.location.href = '/cart'; return; }
      var updates = {}; d.variantIds.forEach(function(vid){ updates[vid] = 0; });
      return post('/cart/update.js', { updates: updates })
        .then(function(){ return post('/cart/add.js', { items: [{ id: parseInt(c.vid, 10), quantity: 1 }] }); })
        .then(function(){ window.location.href = '/cart'; });
    }).catch(function(){ btn.disabled = false; btn.textContent = 'Upgrade to 30ml →'; });
  }, true);

  // ── Empty cart drawer: "Continue shopping" closes the drawer instead of navigating away. ──────
  // The same snippet renders on /cart, where there is no drawer; there the link keeps working as a link.
  document.addEventListener('click', function(ev){
    var b = ev.target && ev.target.closest ? ev.target.closest('.cart-items__empty-button') : null;
    if(!b) return;
    var drawer = b.closest('cart-drawer-component');
    if(!drawer) return;
    ev.preventDefault(); ev.stopPropagation();
    if(typeof drawer.close === 'function'){ drawer.close(); return; }
    var dlg = drawer.querySelector('dialog'); if(dlg && typeof dlg.close === 'function'){ dlg.close(); return; }
    var x = drawer.querySelector('.cart-drawer__close-button'); if(x){ x.click(); }
  }, true);
})();
